<template>
  <header class="ut-block ut-pt-6 md:ut-pt-12 md:ut-pb-6 ut-pb-8">
    <div class="ut-flex ut-items-center ut-justify-between ut-mb-8">
      <router-link tag="div" class="header-back-btn ut-flex ut-items-center ut-m-0"
                  v-gaEvent="{ category: 'Prospecting Tool Agent portal',
                                action: 'Click back to prospecting' }"
                  :to="{ name: 'prospecting' ,
                         params : {ak: $route.params.ak },
                         hash: $route.hash  }" >
          <svg-loader :name="'icon-arrow-back'" :width="18" class="ut-m-0" />
          <span class="ut-m-0 ut-ml-8">Prospecting</span>
      </router-link>
      <pill v-if="prospectBadge"
            :danger="hasNotAttempted"
            class="md:ut-hidden ut-mr-0">{{ prospectBadge }}</pill>
    </div>
    <div class="ut-flex ut-justify-between">
      <div class="ut-ml-0">
        <h1 class="ut-mb-1 ut-text-neutral-900 ut-capitalize">
          {{ prospect.contact.firstName }} {{ prospect.contact.lastName }}
        </h1>
        <p v-if="!loading && contactPropertyAddress"
           class="ut-text-neutral-400 ut-text-base">
           {{ contactPropertyAddress }}</p>
      </div>
      <div class="header-actions ut-mr-0 ut-hidden md:ut-inline-flex">
        <ul class=" ut-flex ut-text-center ut-text-neutral-400">
          <li v-if="prospect.contact.phone"
              @click="clickContactBtn('phone')"
              class="ut-w-32 ut-h-10 ut-p-0 btn btn-green ut-flex">
            <svg-loader :name="'icon-phone'" :width="17" class="ut-mr-0" />
            <span class="ut-ml-2">{{ callBtnText }}</span>
          </li>
          <li v-if="prospect.contact.email"
              @click="clickContactBtn('email')" class="ut-w-10 ut-h-10 btn ut-p-0 ut-mx-1 ut-flex">
            <svg-loader :name="'icon-mail'" :width="20" :height="17" />
          </li>
          <li v-if="prospectBadge !== 'Removed'"
              class="ut-w-10 ut-h-10 ut-p-0 btn ut-flex"
              @click="showModal('prospecting-remove-prospect-modal', removeProspectData)">
            <svg-loader :name="'icon-trash'" :width="22" />
          </li>
        </ul>
      </div>
    </div>
    <div class="ut-flex ut-justify-between ut-border-t
                ut-border-b ut-border-neutral-080 ut-py-4 ut-my-6">
      <div v-if="!loading && topActivitySummary" class="ut-ml-0 ut-flex ut-content-center">
        <svg-loader
          :name="'icon-lightbolt'"
          :color-class="'ut-text-orange-400'"
          :width="20"
          :height="20"
          class="ut-circle-img ut-inline-flex ut-w-6 ut-h-6 bg-opacity
            ut-align-middle ut-mr-2 ut-flex-shrink-0" />
        <p class="ut-text-neutral-400 ut-text-sm md:ut-text-base ut-pt-1">{{ topActivitySummary }}</p>
      </div>
      <div class="ut-mr-0 ut-flex">
      <pill :danger="prospectBadge === 'Not attempted' ? true : false"
            class="ut-hidden md:ut-inline-flex">{{ prospectBadge }}</pill>
        <avatar v-tooltip="{content: `Contact owner - ${agent.name}`, trigger: 'hover click'}"
          class="agent-avatar-sm ut-ml-2 ut-cursor-pointer"
          :size="'sm'"
          :imgSrc="agent && agent.imageurl"
        />
      </div>
    </div>
    <div class="header-actions ut-mr-0 md:ut-hidden">
      <ul class="ut-flex ut-text-center ut-text-neutral-400">
        <li v-if="prospect.contact.phone"
            @click="clickContactBtn('phone')"
            class="ut-w-full ut-h-12 ut-p-0 btn btn-green ut-m-0 ut-flex">
          <svg-loader :name="'icon-phone'" :width="17" class="ut-mr-0" />
          <span class="ut-ml-2">{{ callBtnText }}</span>
        </li>
        <li v-if="prospect.contact.email"
            @click="clickContactBtn('email')"
            class="ut-w-12 ut-h-12 btn ut-p-0 ut-mx-2 ut-flex ut-flex-shrink-0">
          <svg-loader :name="'icon-mail'" :width="20" :height="17" />
        </li>
        <li v-if="prospectBadge !== 'Removed'"
            class="ut-w-12 ut-h-12 ut-p-0 btn ut-flex ut-m-0 ut-flex-shrink-0"
            @click="showModal('prospecting-remove-prospect-modal', removeProspectData)">
          <svg-loader :name="'icon-trash'" :width="22" />
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import Pill from '@/components/Pill.vue';
import Avatar from '@/components/Avatar.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';
import ProspectingHelpers from '@/helpers/prospecting-helpers';
import {
  ProspectActivityActionTypeId,
  ProspectSellingTimeframeId,
  OaLeadSourceTypeId,
} from '@/Mapper/ProspectActivityActionType';

export default {
  name: 'ProspectHeader',
  components: {
    Pill,
    Avatar,
    SvgLoader,
  },
  props: {
    prospect: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  computed: {
    ...mapGetters('prospectStore', [
      'activteReminder',
      'topActivity',
    ]),
    ...mapState({
      stages: state => state.prospectStore.stages,
      agent: state => state.agentStore.agent,
    }),
    hasNotAttempted() {
      return ProspectingHelpers.hasNotAttempted(this.prospect.stage);
    },
    prospectBadge() {
      return ProspectingHelpers.getProspectStageBadge(this.prospect);
    },
    hasAttempted() {
      if (!this.stages) {
        return false;
      }
      return ProspectingHelpers.prospectHasStage(this.stages, ProspectStageType.attempted);
    },
    callBtnText() {
      if (this.hasAttempted) {
        return this.prospect.contact.phone;
      }
      return 'Call';
    },
    topActivitySummary() {
      return ProspectingHelpers.getPropsectActivitySummary(this.topActivity);
    },
    contactPropertyAddress() {
      if (this.topActivity && this.topActivity.contactPropertyAddress) {
        return this.$options.filters.address(this.topActivity.contactPropertyAddress, true) || null;
      }

      if (this.topActivity
        && this.topActivity.actionType.activityActionTypeId === ProspectActivityActionTypeId.oaMatch
        && !this.topActivity.contactPropertyAddress) {
        return 'Active near your agency';
      }

      return null;
    },
    removeProspectData() {
      return {
        prospect: this.prospect,
        topActivity: this.topActivity,
      };
    },
  },
  mounted() {},
  methods: {
    ...mapActions('prospectStore', [
      'createStage',
    ]),
    showModal(name, data) {
      this.$modal.show(name, data);
    },
    clickContactBtn(type) {
      if (!this.hasAttempted) {
        // create attempted stage
        const payload = {
          prospectKey: this.prospect.key,
          stageTypeId: ProspectStageType.attempted,
          creatorUserId: this.userid,
        };
        this.createStage(payload);
      }
      if (type === 'phone') {
        window.location = `tel:${this.prospect.contact.phone}`;
      } else { // must be email
        window.location = `mailto:${this.prospect.contact.email}`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h1 {
    font-size: 28px;
    @apply ut-font-semibold;
  }
  .bg-opacity {
    background: #F9A568; /* The Fallback */
   background: rgba(#F9A568, 0.5);
  }

  .header-back-btn {
  @apply ut-cursor-pointer ut-uppercase;
  font-size: 12px;
  letter-spacing: 1.07px;
  line-height: 15px;
}
</style>
